import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "t-center my-32 flex-1" }
const _hoisted_2 = { class: "c-tip f-sm" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("There is no data!")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pic = _resolveComponent("Pic")

  return (_ctx.isNull)
    ? _renderSlot(_ctx.$slots, "empty", { key: 0 }, () => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_Pic, {
            src: "blank",
            width: "32",
            height: "32"
          }),
          _createVNode("p", _hoisted_2, [
            _renderSlot(_ctx.$slots, "emptyMsg", {}, () => [
              _hoisted_3
            ])
          ])
        ])
      ])
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}